import {getRedirectUri} from '@/pages/User/pages/VerifyLinkedinAuthentication/hooks/utils';
import {ENTRYPOINTS, LINKEDIN_API_CONFIG} from './constants';

export const getLinkedinAuthorizationUrl = (state: string) => {
    return `${LINKEDIN_API_CONFIG.AUTHORIZATION_URL}?response_type=${LINKEDIN_API_CONFIG.RESPONSE_TYPE}&client_id=${LINKEDIN_API_CONFIG.CLIENT_ID}&state=${state}&redirect_uri=${getRedirectUri()}&scope=${LINKEDIN_API_CONFIG.SCOPE}`;
};

export const getEntrypoint = (redirectTo: string) => {
    if (redirectTo.includes('jobs')) {
        return ENTRYPOINTS.MY_JOBS_TAB;
    }
    if (redirectTo.includes('readiness-data-collection')) {
        return ENTRYPOINTS.READINESS_DATA_COLLECTION_PAGE;
    }
    if (redirectTo.includes('apply')) {
        return ENTRYPOINTS.APPLICATION_PAGE;
    }
    return 'UNKNOWN';
};
